import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { NotebookPen, Plus, Trash2, Save } from "lucide-react";
import api from "../../lib/api";

export function MisNotas() {
  const [notas, setNotas] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/descargas/notas/mias").then((r) => setNotas(r.data.notas)).catch(() => {});
  useEffect(() => { load(); }, []);

  const guardar = async () => {
    if (!edit.titulo.trim()) { toast.error("Ponle un título a la nota"); return; }
    const body = { titulo: edit.titulo.trim(), texto: edit.texto };
    try {
      if (edit.id) await api.put(`/descargas/notas/mias/${edit.id}`, body); else await api.post("/descargas/notas/mias", body);
    } catch { toast.error("No se pudo guardar la nota"); return; }
    toast.success("Nota guardada");
    setEdit(null);
    load();
  };
  const borrar = async (n) => {
    if (!window.confirm(`¿Borrar la nota «${n.titulo}»?`)) return;
    try { await api.delete(`/descargas/notas/mias/${n.id}`); } catch { toast.error("No se pudo borrar la nota"); }
    load();
  };

  return (
    <section className="mt-10" data-testid="mis-notas">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-4">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold flex items-center gap-1"><NotebookPen size={12} /> Solo las ves tú</div>
          <h2 className="font-display text-2xl font-extrabold tracking-tight">Mis notas</h2>
        </div>
        <button className="btn btn-primary" onClick={() => setEdit({ titulo: "", texto: "" })} data-testid="nota-nueva"><Plus size={14} /> Nueva nota</button>
      </div>
      {edit && (
        <div className="card p-4 mb-4 space-y-2 border-l-4 border-l-sky-500" data-testid="nota-editor">
          <input className="input w-full" placeholder="Título" value={edit.titulo} onChange={(e) => setEdit({ ...edit, titulo: e.target.value })} data-testid="nota-titulo" />
          <textarea className="input w-full min-h-[120px]" placeholder="Escribe aquí…" value={edit.texto} onChange={(e) => setEdit({ ...edit, texto: e.target.value })} data-testid="nota-texto" />
          <div className="flex gap-2">
            <button className="btn btn-primary" onClick={guardar} data-testid="nota-guardar"><Save size={14} /> Guardar</button>
            <button className="btn btn-outline" onClick={() => setEdit(null)} data-testid="nota-cancelar">Cancelar</button>
          </div>
        </div>
      )}
      {!notas.length && !edit && <p className="text-sm text-slate-500" data-testid="notas-vacio">Aún no tienes notas. Apunta aquí lo que quieras recordar de los manuales y vídeos.</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {notas.map((n) => (
          <div key={n.id} className="card p-4 cursor-pointer hover:shadow-md transition-shadow" onClick={() => setEdit(n)} data-testid={`nota-${n.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div className="font-semibold">{n.titulo}</div>
              <button onClick={(e) => { e.stopPropagation(); borrar(n); }} className="text-red-400 hover:text-red-600" data-testid={`nota-borrar-${n.id}`}><Trash2 size={14} /></button>
            </div>
            <p className="text-sm text-slate-600 mt-1 whitespace-pre-wrap line-clamp-4">{n.texto}</p>
            <div className="text-[11px] text-slate-400 mt-2">{new Date(n.updated_at).toLocaleString("es-ES")}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
